const tables = document.querySelectorAll('.variant__description')
// let params = new URLSearchParams(window.location.search)

document.querySelectorAll('.swatch-element').forEach(function (variant) {
  variant.addEventListener('click', (e) => {
    setTimeout(function () {
      const priceEl = document.querySelector('#price-field span.money');
      const metafieldMoneyEl = document.querySelector('.metafield-money');
      if (priceEl && metafieldMoneyEl) {
        metafieldMoneyEl.innerHTML = priceEl.innerHTML + ' Brutto';
      }
    }, 200);

    const params = new URLSearchParams(window.location.search);
    const selectedVariantId = params.get('variant');

    tables.forEach(function (table) {
      table.style.display = 'none';
      if (selectedVariantId && selectedVariantId === table.dataset.variantId) {
        table.style.display = 'block';
      }
    });
  });
});
